import React, { useState } from "react";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import { Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Eye, X } from "lucide-react";

export default function Layout() {
  const [navOpen, setNavOpen] = useState(false);
  const { isAdmin, isStaff, viewAs, viewAsName, setViewAs } = useAuth();
  const impersonating = isAdmin && viewAs && viewAs !== "all";

  // Desktop rail collapse — staff default to collapsed so the Ops Console gets
  // the full width; brand users keep the nav expanded. Resolved synchronously
  // on first render (user is already authenticated here) to avoid any flash.
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("bh_nav_collapsed");
    if (saved !== null) return saved === "1";
    return !!isStaff;
  });
  const toggleCollapse = () => {
    setCollapsed((c) => {
      localStorage.setItem("bh_nav_collapsed", c ? "0" : "1");
      return !c;
    });
  };

  return (
    <div className="min-h-screen bg-bh-bg">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} collapsed={collapsed} />
      <Topbar onMenuClick={() => setNavOpen(true)} collapsed={collapsed} onToggleCollapse={toggleCollapse} />
      <main className={`${collapsed ? "lg:ml-0" : "lg:ml-64"} pt-20 px-4 sm:px-6 lg:px-8 pb-12 transition-[margin] duration-200`}>
        {impersonating && (
          <div
            data-testid="impersonation-banner"
            className="flex items-center justify-between gap-3 bg-bh-navy-deep text-white rounded-lg px-4 py-2.5 mb-5"
          >
            <div className="flex items-center gap-2 text-sm min-w-0">
              <Eye className="w-4 h-4 text-bh-orange shrink-0" />
              <span className="truncate">
                Viewing as <strong>{viewAsName || "selected store"}</strong>
              </span>
            </div>
            <button
              data-testid="exit-impersonation-btn"
              onClick={() => setViewAs("all", "All accounts")}
              className="inline-flex items-center gap-1 text-xs font-semibold bg-white/15 hover:bg-white/25 px-3 py-1.5 rounded-md transition-colors shrink-0"
            >
              <X className="w-3.5 h-3.5" /> Exit to all
            </button>
          </div>
        )}
        <div className="animate-fade-in-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
